<template>
  <div>
    <v-snackbar
      v-model="show"
      :left="opt.left"
      :right="opt.right"
      :top="opt.top"
      :bottom="opt.bottom"
      :vertical="opt.vertical"
      :color="opt.color"
      :timeout="opt.timeout"
      :multiLine="opt.multiLine"
    >
      <div :class="{ 'center-right': !opt.multiLine }">
        <div
          :style="{
            display: opt.multiLine ? 'block' : 'inline',
            'font-size': '12px',
          }"
          :class="{ 'px-2': opt.multiLine }"
        >
          {{ opt.text }}
        </div>

        <div
          v-if="opt.actionBtn"
          :class="{
            'center-right': opt.multiLine,
            'mr-auto': !opt.multiLine,
          }"
        >
          <span class="mr-auto">
            <slot name="action">
              <v-btn
                v-if="opt.multiLine"
                text
                color="#BF89FF"
                class="bold"
                @click="$store.state.showSnackbar = false"
              >
                بستن
              </v-btn>
              <v-icon
                v-else
                size="20"
                @click="$store.state.showSnackbar = false"
              >
                mdi-close
              </v-icon>
            </slot>
          </span>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  computed: {
    opt() {
      return this.$store.state.snackbarOptions;
    },
    show: {
      get() {
        return this.$store.state.showSnackbar;
      },
      set(val) {
        this.$store.state.showSnackbar = val;
      },
    },
  },
};
</script>

<style>
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
